import React from "react";
import { Sparkles } from "lucide-react";
import ShadowZoneCustomiser from "./ShadowZoneCustomiser";

/**
 * ShadowZoneProfileCard — Settings entry. Optional. Only meaningful
 * for users who experience beard shadow; we surface it for everyone
 * but copy keeps it neutral so nobody feels presumed.
 */
const ShadowZoneProfileCard = () => (
  <div
    className="bg-white/80 backdrop-blur-xl border border-[#EADDD7] rounded-3xl p-7 soft-shadow mb-5"
    data-testid="shadow-zone-profile-card"
  >
    <div className="flex items-start gap-4 mb-5">
      <div className="shrink-0 h-11 w-11 rounded-full bg-[#F2E8E9] flex items-center justify-center">
        <Sparkles className="h-5 w-5 text-[#9B6A6C]" />
      </div>
      <div className="flex-1">
        <h3 className="text-xl font-medium text-[#2C2123] leading-tight mb-1">
          My shadow zones
        </h3>
        <p className="text-sm text-[#5C4B51] max-w-xl">
          Tell the AR mirror exactly where your shadow lives so Trouvé
          guides your corrector to your face — not a one-size-fits-all
          map. You can add or remove zones any time.
        </p>
      </div>
    </div>

    <ShadowZoneCustomiser mode="settings" />
  </div>
);

export default ShadowZoneProfileCard;
